export default __webpack_public_path__ + "static/media/amm_logo.e13fbe5b.svg";